import { withContext } from 'common/utils/context';
import { signatureRequestContext, fieldsContext, SignatureRequestContext, zoomContext, ZoomContextShape } from './context';
import Document from './document';
import Handle from './handle';
import DisplayField from './display-field';
import {
  ORIGIN_VIEWPORT,
  ORIGIN_PAGE,
  ORIGIN_PAGE_CONTAINER,

  PREPARER,
  SENDER,

  MIN_FONT_SIZE,
  DEFAULT_FONT_SIZE,
  DEFAULT_FONT_FAMILY,
  DEFAULT_DATE_FORMAT,

  FIT_WIDTH,

  fontFamilies,
} from './constants';

export {
  signatureRequestContext,
  fieldsContext,
  SignatureRequestContext,
  zoomContext,
  ZoomContextShape,
  Handle,
  DisplayField,

  ORIGIN_VIEWPORT,
  ORIGIN_PAGE,
  ORIGIN_PAGE_CONTAINER,

  PREPARER,
  SENDER,

  MIN_FONT_SIZE,
  DEFAULT_FONT_SIZE,
  DEFAULT_FONT_FAMILY,
  DEFAULT_DATE_FORMAT,

  FIT_WIDTH,

  fontFamilies,
};

export const withSignatureRequestContext = withContext(signatureRequestContext, 'signatureRequestContext');

export default Document;

export const getBoundingBox = (fields) => fields.reduce((bbox, field) => {
  const x = Math.min(bbox.x, field.x);
  const y = Math.min(bbox.y, field.y);
  const width = Math.max(
    (bbox.x + bbox.width) - x,
    (field.x + field.width) - x,
  );
  const height = Math.max(
    (bbox.y + bbox.height) - y,
    (field.y + field.height) - y,
  );

  return {
    x, y, width, height,
  };
});
